// src/pages/Lily.jsx
import React, { useEffect, useState } from 'react';
import '../CSS/Lily.css';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Contactbar from '../Components/ContactBar';
import lilyHero from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7578.jpg";
import { FaUsers, FaParking, FaWifi, FaUtensils, FaMusic, FaCamera } from 'react-icons/fa';
import layoutPDF1 from '../assets/WEDDING LAYOUT -1.pdf';
import layoutPDF2 from '../assets/WEDDING LAYOUT -2.pdf';
import layoutPDF3 from '../assets/WEDDING LAYOUT -3.pdf';
import layoutPDF4 from '../assets/WEDDING LAYOUT -4.pdf';
import layoutPDF5 from '../assets/WEDDING HALF HALL.pdf';
import layoutPDF6 from '../assets/RECEPTION LAYOUT -1.pdf';
import layoutPDF7 from '../assets/RECEPTION LAYOUT -2.pdf';
import layoutPDF8 from '../assets/RECEPTION LAYOUT -3.pdf';

import img1 from "../assets/WEDDING LAYOUT -1.jpg";
import img2 from "../assets/WEDDING LAYOUT -2.jpg";
import img3 from "../assets/WEDDING LAYOUT -3.jpg";
import img4 from "../assets/WEDDING LAYOUT -4.jpg";
import img5 from "../assets/WEDDING HALF HALL.jpg";
import img6 from "../assets/RECEPTION LAYOUT -1.jpg";
import img7 from "../assets/RECEPTION LAYOUT -2.jpg";
import img8 from "../assets/RECEPTION LAYOUT -3.jpg";

const Lily = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const layoutData = [
    { pdf: layoutPDF1, title: "Wedding Layout 1", image: img1 },
    { pdf: layoutPDF2, title: "Wedding Layout 2", image: img2 },
    { pdf: layoutPDF3, title: "Wedding Layout 3", image: img3 },
    { pdf: layoutPDF4, title: "Wedding Layout 4", image: img4 },
    { pdf: layoutPDF5, title: "Wedding Half Hall Layout", image: img5 },
    { pdf: layoutPDF6, title: "Reception Layout 1", image: img6 },
    { pdf: layoutPDF7, title: "Reception Layout 2", image: img7 },
    { pdf: layoutPDF8, title: "Reception Layout 3", image: img8 },
  ];

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `*Lily Layout Booking Request*\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Phone:* ${formData.phone}\n*Message:* ${formData.message}`;
    const phoneNumber = '919909254684';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    setShowModal(false);
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <>
      <Header />

      <section className="lily-layout-page">
        <br/>
        <h1 className="layout-title">Lily Banquet Layout Designs</h1>

        {/* <img src={lilyHero} alt="Lily Banquet Hall" className="layout-hero-image" /> */}

        <p className="layout-description">
Lily Banquet Hall is where your grandest celebrations become a reality. We offer a truly luxurious setting with sophisticated décor and state-of-the-art amenities, designed to host events that are nothing short of unforgettable. Whether you're orchestrating a magnificent wedding, a lavish reception, or a large-scale corporate gala, our expansive venue ensures a seamless and spectacular experience with top-notch facilities and exceptional service.
<br/>
<br/>
At Lily Banquet Hall, we understand that every large event has unique requirements. That's why we specialize in providing flexible and bespoke layout designs. Our experienced team will work closely with you to customize the space, whether you envision an opulent banquet setup, a vibrant reception with multiple stations, or a professional conference arrangement, ensuring your event unfolds perfectly.
<br/>
<br/>
          <h3>Key Features</h3>
          <div className="libra-features">
            <div className="libra-feature-item"><FaUsers className="icon" /> 500 Guest Capacity</div>
            <div className="libra-feature-item"><FaParking className="icon" /> Standard Parking</div>
            <div className="libra-feature-item"><FaWifi className="icon" /> High-Speed WiFi</div>
            <div className="libra-feature-item"><FaCamera className="icon" /> Photo Zones</div>
          </div>


        </p>

        <div className="layout-button-grid">
          {layoutData.map((layout, index) => (
            <div className="layout-download-card" key={index}>
              <img src={layout.image} alt={layout.title} style={{ width: '100%', borderRadius: '8px', marginBottom: '0.8rem' }} />
              <h4>{layout.title}</h4>
              <a href={layout.pdf} download target="_blank" rel="noopener noreferrer" className="download-btn">Download PDF</a>
            </div>
          ))}
        </div>
      </section>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h3>Book Layout</h3>
            <form className="modal-form" onSubmit={handleSubmit}>
              <input type="text" placeholder="Your Name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
              <input type="email" placeholder="Your Email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required />
              <input type="tel" placeholder="Your Phone" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} required />
              <textarea placeholder="Message / Special Requests" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })}></textarea>
              <div className="modal-actions">
                <button type="submit" className="submit-btn">Send</button>
                <button type="button" className="close-btn" onClick={() => setShowModal(false)}>Close</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="libra-cta-wrapper">
        <section className="libra-booking-cta">
          <h2>Ready to Book Your Event ?</h2>
          <p>Make your celebration unforgettable at Lily Banquet Hall. Contact us now to check availability and receive a customized quote for your special occasion.</p>
          <div className="cta-buttons">
            <button className="book-now" onClick={() => setShowModal(true)}>Book Now</button>
            <a href="/venues" className="contact">Back to Venues</a>
          </div>
        </section>
      </div>

      <Contactbar />
      <Footer />
    </>
  );
};

export default Lily;
